module.exports = require('./helpers/bundle-url').getBundleURL('hdhZv') + "walnut-haven-abstract-balmoral-1.71828ba7.jpg";